// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hs5-","title":"styles_title__3REuv"};